var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationIlustration = function SvgNotificationIlustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 62 62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#63B9E9",
    fillRule: "evenodd",
    d: "M27.458 14.48a14.201 14.201 0 0 0-10.632 13.756v9.468c0 .873-.707 1.58-1.573 1.58a3.156 3.156 0 0 0 .006 6.313h31.485a3.16 3.16 0 0 0 3.158-3.157 3.158 3.158 0 0 0-3.152-3.156 1.573 1.573 0 0 1-1.573-1.58v-9.468c0-6.618-4.517-12.18-10.632-13.756v-1.63A3.544 3.544 0 0 0 31.001 9.3a3.55 3.55 0 0 0-3.543 3.551v1.63Zm-1.969 32.695h11.025a5.518 5.518 0 0 1-5.512 5.524 5.518 5.518 0 0 1-5.513-5.524Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "notification_ilustration_svg__a",
    width: 38,
    height: 44,
    x: 12,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#74C1EC",
    fillRule: "evenodd",
    d: "M27.458 14.48a14.201 14.201 0 0 0-10.632 13.756v9.468c0 .873-.707 1.58-1.573 1.58a3.156 3.156 0 0 0 .006 6.313h31.485a3.16 3.16 0 0 0 3.158-3.157 3.158 3.158 0 0 0-3.152-3.156 1.573 1.573 0 0 1-1.573-1.58v-9.468c0-6.618-4.517-12.18-10.632-13.756v-1.63A3.544 3.544 0 0 0 31.001 9.3a3.55 3.55 0 0 0-3.543 3.551v1.63Zm-1.969 32.695h11.025a5.518 5.518 0 0 1-5.512 5.524 5.518 5.518 0 0 1-5.513-5.524Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#notification_ilustration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2276A6",
    d: "M32.928 15.074c0-3.15-1.05-4.725-2.1-5.775h19.6v43.4h-19.6c2.45-1.75 2.1-5.775 2.1-5.775l11.725-.7v-.7c0-4.55-1.575-4.9-2.275-5.6-.56-.56-.583-1.05-.525-1.225 0-16.975-.875-15.575-8.925-23.625Z"
  }))));
};
export default SvgNotificationIlustration;